import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getAllOwnersCellValue } from 'src/rbac/contributorHelper';

import type {
  AssessmentRCSAActivityFields,
  AssessmentRCSAActivityRegisterFields,
} from './types';

export const useLabelledFields = (
  records: AssessmentRCSAActivityFields[] | undefined
) => {
  const { t } = useTranslation(['common'], {
    keyPrefix: 'assessmentActivities',
  });
  const status = t('status');
  const type = t('type');
  const labelledFields = useMemo<
    AssessmentRCSAActivityRegisterFields[] | undefined
  >(() => {
    return records?.map((d) => {
      return {
        ...d,
        StatusLabelled: d.Status ? status[d.Status] : '-',
        ActivityTypeLabelled: d.IsRCSA
          ? t('rcsa')
          : d.ActivityType
            ? type[d.ActivityType]
            : '-',
        CreatedById: d.CreatedByUser,
        CreatedByUsername: d.createdByUser?.FriendlyName ?? '-',
        CreatedOn: d.CreatedAtTimestamp,
        UpdatedById: d.ModifiedByUser,
        UpdatedByUsername: d.modifiedByUser?.FriendlyName ?? '-',
        LinkedRisk: d.parentRisk?.Title,
        LinkedRiskSequentialId: d.parentRisk?.SequentialId,
        allAssignedUsers: getAllOwnersCellValue(d),
      };
    });
  }, [records, status, type, t]);

  return labelledFields;
};
